import config from "../config";

interface SubscribePayload {
    phone: string;
    email?: string;
    customerId?: number | null;
    cookies: string;
    creativeId: string;
}

export default class SmsSubscriptionClient {
    subscribe = async ({ phone, email, cookies, creativeId, customerId }: SubscribePayload) => {
        // Regex retrieved from https://docs.attentive.com/pages/api-reference/add-subscribers/
        const visitorId = cookies.replace(/(?:(?:^|.*;\s*)__attentive_id\s*=\s*([^;]*).*$)|^.*$/u, "$1");
        const formData = new FormData();
        formData.append("creativeId", creativeId);
        formData.append("visitorId", visitorId);
        formData.append("phone", phone);
        if (email) {
            formData.append("email", email);
        }
        if (customerId) {
            formData.append("customerId", customerId.toString());
        }

        try {
            await fetch(config.ALLIT_URL + "/onnit/req/attentive-signup.php", {
                method: "POST",
                body: formData,
            });
            console.info("SMS subscribed phone=%s, visitorId=%s, creativeId=%s", phone, visitorId, creativeId);
        } catch (error) {
            console.error("Failed to SMS subscribe phone=%s, error=%s", phone, error);
        }
    };
}
